



















/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import GeometryType from '@/models/map-context/GeometryType';
import LayerConfig from '@/models/map-context/LayerConfig';
import StyleRule from '@/models/map-context/style/StyleRule';
import { EVENTS } from '@/services/EventBus';
import LineString from 'ol/geom/LineString';
import Point from 'ol/geom/Point';
import Polygon from 'ol/geom/Polygon';
import ImageState from 'ol/ImageState';
import { toContext } from 'ol/render';
import { Style } from 'ol/style';
import Component from 'vue-class-component';
import BaseComponent from '../../BaseComponent';

// eslint-disable-next-line no-use-before-define
@Component<VectorLegend>({
  name:'VectorLegend',
  props: {
    layer: LayerConfig,
    rule:StyleRule,
    refreshToken:Number
  },
  components: {
    VectorLegend,
  },
  watch: {
    layer() {
      this.drawVectorLegend();
    },
    refreshToken() {
      this.drawVectorLegend();
    },
    'layer.styleRefreshToken'() {
      this.drawVectorLegend();
    },
    'rule.refreshToken'() {
      this.drawVectorLegend();
    },
    rule() {
      this.drawVectorLegend();
    },
  },
})
export default class VectorLegend extends BaseComponent {
  
  layer!:LayerConfig;

  rule!:StyleRule;

  legendUrl='';

  drawId = 0;

  mounted() {
    console.log(this.rule);
    this.drawVectorLegend();
    this.getEventBus().$on(EVENTS.LAYER_UPDATED, this.onLayerUpdated);
  }

  beforeDestroy() {
    this.drawId += 1;
    this.getEventBus().$off(EVENTS.LAYER_UPDATED, this.onLayerUpdated);
  }

  onLayerUpdated = (layer: LayerConfig) => {
    if (layer && this.layer && (layer === this.layer || layer.uid === this.layer.uid)) {
      this.drawVectorLegend();
    }
  }

  getLabel(rule:StyleRule){
    if(rule.label)
      return rule.label;
    else
     return rule.value;
  }

  getRefreshToken(rule?: StyleRule): number {
    const layerToken = this.layer && this.layer.styleRefreshToken ? this.layer.styleRefreshToken : 0;
    const ruleToken = rule && rule.refreshToken ? rule.refreshToken : 0;
    return layerToken + ruleToken;
  }

  inRange(item:StyleRule) {
    // eslint-disable-next-line prefer-destructuring
    const currentScale = this.getMapService().currentScale;
    return item.inRange(currentScale);
  }

  drawVectorLegend() {
    console.log('drawVectorLegend');
    const currentDraw = this.drawId + 1;
    this.drawId = currentDraw;
    this.$nextTick(() => {
      if (currentDraw !== this.drawId || !this.$refs.canvas) {
        return;
      }
      const layerStyle = this.rule ? this.rule.style : (this.layer && this.layer.style);
      if (this.ensureSvgData(layerStyle, currentDraw)) {
        return;
      }
      const canvasref: any = this.$refs.canvas;
      const ctx: CanvasRenderingContext2D = <any>canvasref.getContext('2d');
      let height = 30;
      if (this.layer && this.layer.geometryType === GeometryType.POINT) {
        if (this.rule) {
          height = 20 + Number(this.rule.style.pointSymbol.getSize());
        } else {
          height = 20 + Number(this.layer.style.pointSymbol.getSize());
        }
      }
      canvasref.width = 100;
      canvasref.height = height;
      ctx.clearRect(0, 0, canvasref.width, canvasref.height);
      const vectorContext = toContext(ctx, { size: [100, height] });
      let styles: Style[] = [];
      if (this.rule) {
        styles = this.rule.style.getStyle(undefined, undefined, true);
      } else if (this.layer) {
        styles = this.layer.style.getStyle(undefined, undefined, true);
      }
      if (!styles || styles.length === 0) {
        return;
      }
      this.whenOlIconsReady(styles, () => {
        if (currentDraw !== this.drawId || !this.$refs.canvas) {
          return;
        }
        this.paintLegend(vectorContext, styles, height);
      });
    });
  }

  /**
   * toContext ne dessine un Icon que si l'image est déjà chargée.
   * Si le SVG n'est pas encore en mémoire (typiquement WMS / SLD),
   * on le fetch puis on relance le dessin.
   */
  ensureSvgData(layerStyle: any, currentDraw: number): boolean {
    if (!layerStyle || typeof layerStyle.getPointSymbolType !== 'function'
      || layerStyle.getPointSymbolType() !== 'svg' || !layerStyle.pointSymbol) {
      return false;
    }
    const symbol = layerStyle.pointSymbol;
    if (symbol.getSvgContent() || !symbol.getSvgIconUrl()) {
      return false;
    }
    const img = symbol.fetchIcon();
    const retry = () => {
      if (currentDraw === this.drawId) {
        this.drawVectorLegend();
      }
    };
    if (img) {
      img.addEventListener('load', retry, { once: true });
      img.addEventListener('error', retry, { once: true });
    }
    return true;
  }

  whenOlIconsReady(styles: Style[], onReady: () => void): void {
    const pending: any[] = [];
    styles.forEach((style: Style) => {
      const image: any = style.getImage ? style.getImage() : null;
      if (!image || typeof image.load !== 'function' || typeof image.getImageState !== 'function') {
        return;
      }
      if (image.getImageState() === ImageState.LOADED) {
        return;
      }
      pending.push(image);
    });
    if (pending.length === 0) {
      onReady();
      return;
    }
    let remaining = pending.length;
    let finished = false;
    const done = () => {
      if (finished) {
        return;
      }
      remaining -= 1;
      if (remaining <= 0) {
        finished = true;
        onReady();
      }
    };
    pending.forEach((image: any) => {
      const htmlImg = typeof image.getImage === 'function' ? image.getImage(1) : null;
      if (htmlImg && htmlImg.addEventListener) {
        htmlImg.addEventListener('load', done, { once: true });
        htmlImg.addEventListener('error', done, { once: true });
      }
      image.load();
      if (image.getImageState() === ImageState.LOADED) {
        done();
      }
    });
    setTimeout(() => {
      if (!finished) {
        finished = true;
        onReady();
      }
    }, 3000);
  }

  paintLegend(vectorContext: any, styles: Style[], height: number): void {
    if (this.layer && this.layer.geometryType === GeometryType.LINE) {
      vectorContext.setStyle(styles[0]);
      vectorContext.drawGeometry(new LineString([[2, 2], [20, 30], [30, 2], [58, 30]]));
    } else if (this.layer && this.layer.geometryType === GeometryType.POINT) {
      for (let i = 0; i < styles.length; i++) {
        vectorContext.setStyle(styles[i]);
        vectorContext.drawGeometry(new Point([50, height / 2]));
      }
    } else {
      vectorContext.setStyle(styles[0]);
      vectorContext.drawGeometry(new Polygon([[[2, 2], [58, 2], [58, 28], [2, 28], [2, 2]]]));
    }
  }
}
